<template>
  <div class="blog-page-white-bg blog-v3">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="feature-blog-three">

            <div v-for="blogitem in blogitems" :key="blogitem.id" class="post-meta">
              <!-- Fixed image path handling -->
              <img v-if="blogitem.image" :src="getImageUrl(blogitem.image)" alt="" class="image-meta">

              <div class="post">
                <div class="date">{{blogitem.publish}}</div>
                <h3>
                  <router-link :to="`/blog-details/?id=${blogitem.id}`" class="title">{{blogitem.title}}</router-link>
                </h3>
                <p>{{blogitem.summary}}</p>
                <router-link :to="`/blog-details/?id=${blogitem.id}`" class="read-more">
                  <span>Continue Reading</span>
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </router-link>
              </div>
            </div> <!-- /.post-meta -->
  
          </div>

          <!-- <div class="page-pagination-one pt-15">
            <ul class="d-flex align-items-center">
              <li><a href="#"><i class="fa fa-angle-left" aria-hidden="true"></i></a></li>
              <li><a href="#" class="active">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li> &nbsp; ... &nbsp;</li>
              <li><a href="#">13</a></li>
              <li><a href="#"><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>
            </ul>
          </div>  -->
          <!-- /.page-pagination-one -->
        </div>
        <div class="col-lg-4 col-md-6">
          <!-- BlogSidebar start -->
          <BlogSidebar :blog_v3="true" />
          <!-- BlogSidebar end -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogSidebar from '../common/blog-sidebar.vue';
import axios from 'axios';

export default {
  name: 'BlogArea',
  components: { BlogSidebar },
  data() {
    return {
      blogitems: [],
      blogIdMap: {},
    };
  },

  methods: {
    // Method to handle image URLs properly
    getImageUrl(imagePath) {
    console.log("images is definging;;;");
      // If the image path is a full URL or from Strapi media
      if (imagePath.startsWith('http') || imagePath.startsWith('/uploads')) {
        return imagePath;
      }
      
      // For local images
      try {
        return require(`@/assets/images/blog/${imagePath}`);
      } catch (error) {
        console.warn(`Image not found: ${imagePath}`);
        return ''; // Return empty or a placeholder image
      }
    }
  },

  async mounted() {
    try {
      const response = await axios.get(`${process.env.VUE_APP_STRAPI_URL}/api/blogs`);
      const items = response.data.data;
      console.log('Strapi response:', items);
      
      if (!items || !Array.isArray(items)) {
        console.error('Invalid response format from Strapi');
        return;
      }

      // Map the Strapi response to our blog items
      this.blogitems = items.map(item => ({
        id: item.id,
        ...item.attributes,
      }));
      
      // Create the ID map
      this.blogIdMap = items.reduce((map, item, index) => {
        map[index] = item.id;
        return map;
      }, {});
      
      console.log('Processed blog items:', this.blogitems);
    } catch (error) {
      console.error('Error fetching blogs from Strapi:', error);
    }
  },
}
</script>